import * as types from '../../mutation-types'
import lazyLoading from './lazyLoading'

// show: meta.label -> name
// name: component name
// meta.label: display label
const state = {
  items: [
    {
      name: 'Dashboard',
      path: '/dashboard',
      meta: {
        icon: 'fa-tachometer',
        label: 'Главная'
      },
      component: lazyLoading('Dashboard', false)
    },
    {
      name: 'Users',
      path: '/users',
      meta: {
        icon: 'fa-user',
        label: 'Пользователи',
        expanded: false,
        exact: false,
        can: 'show User'
      },
      component: lazyLoading('users/Users', false)
    },
    {
      name: 'User',
      path: '/users/:id',
      meta: {
        label: 'Пользователь',
        inSideBar: false,
        can: 'show User',
        fail: '/users'
      },
      component: lazyLoading('users/User', false)
    },
    {
      name: 'ClinicsDoctorsServices',
      meta: {
        label: 'Клиники, врачи и услуги',
        icon: 'fa-ambulance',
        expanded: false
      },
      children: [
        {
          name: 'Clinics',
          path: '/clinics',
          meta: {
            label: 'Клиники',
            can: 'show Clinic',
            fail: '/'
          },
          component: lazyLoading('clinics/Clinics', false)
        },
        {
          name: 'Specialities',
          path: '/specialities',
          meta: {
            label: 'Специальности',
            can: 'show Speciality',
            fail: '/'
          },
          component: lazyLoading('specialities/Specialities', false)
        },
        {
          name: 'Doctors',
          path: '/doctors',
          meta: {
            label: 'Врачи',
            can: 'show Doctor',
            fail: '/'
          },
          component: lazyLoading('doctors/Doctors', false)
        },
        {
          name: 'Services',
          path: '/services',
          meta: {
            label: 'Услуги',
            exact: true,
            can: 'show Service',
            fail: '/'
          },
          component: lazyLoading('services/Services', false)
        },
        {
          name: 'HouseCallMaps',
          path: '/house-call-maps',
          meta: {
            label: 'Вызов на дом',
            can: 'show HouseCallMap',
            fail: '/'
          },
          component: lazyLoading('appointments/HouseCallMaps', false)
        }
      ]
    },
    {
      name: 'Clinic',
      path: '/clinics/:id',
      meta: {
        label: 'Клиника',
        inSideBar: false,
        can: 'show Clinic',
        fail: '/clinics'
      },
      component: lazyLoading('clinics/Clinic', false)
    },
    {
      name: 'Speciality',
      path: '/specialities/:id',
      meta: {
        label: 'Специальность',
        inSideBar: false,
        can: 'show Speciality',
        fail: '/specialities'
      },
      component: lazyLoading('specialities/Speciality', false)
    },
    {
      name: 'Service',
      path: '/services/:id',
      meta: {
        label: 'Услуга',
        inSideBar: false,
        can: 'show Service',
        fail: '/services'
      },
      component: lazyLoading('services/Service', false)
    },
    // {
    //   name: 'ServiceCategory',
    //   path: '/service-categories/:id',
    //   meta: {
    //     label: 'Категория услуги',
    //     inSideBar: false,
    //     can: 'show Service',
    //     fail: '/services'
    //   },
    //   component: lazyLoading('services/Category', false)
    // },
    {
      name: 'Reports',
      meta: {
        label: 'Реестры',
        icon: 'fa-line-chart',
        expanded: false
      },
      children: [
        {
          name: 'Appointments',
          path: '/appointments',
          meta: {
            label: 'Записи на прием',
            exact: true,
            can: 'show Appointment'
          },
          component: lazyLoading('appointments/Appointments', false)
        },
        {
          name: 'MultiAppointments',
          path: '/multi-appointments',
          meta: {
            label: 'Записи на программы',
            exact: true,
            can: 'show Appointment'
          },
          component: lazyLoading('appointments/MultiAppointments', false)
        },
        {
          name: 'Payments',
          path: '/payments',
          meta: {
            label: 'Покупки',
            exact: true,
            can: 'show Payment'
          },
          component: lazyLoading('payments/Payments', false)
        },
        {
          name: 'Search',
          path: '/searchterm',
          meta: {
            label: 'Статистика поиска',
            exact: true,
            can: 'show SearchTerm'
          },
          component: lazyLoading('search/Search', false)
        },
        {
          name: 'MedicalCardHistory',
          path: '/mchistories',
          meta: {
            label: 'Статистика поиска ЛК',
            exact: true,
            can: 'show MedicalCardHistory'
          },
          component: lazyLoading('mchistory/MedicalCardHistory', false)
        },
        {
          name: 'UserFileHistory',
          path: '/user-file-histories',
          meta: {
            label: 'Статистика загрузок',
            exact: true,
            can: 'show UserFileHistory'
          },
          component: lazyLoading('user-file-history/History', false)
        }
      ]
    },
    {
      name: 'BlogPosts',
      path: '/blog/posts',
      meta: {
        label: 'Блог',
        icon: 'fa-newspaper-o',
        inSideBar: true,
        can: 'show Post',
        fail: '/'
      },
      component: lazyLoading('blog/Posts', false)
    },
    {
      name: 'BlogPost',
      path: '/blog/posts/:id',
      meta: {
        label: 'Статья',
        inSideBar: false,
        can: 'show Post',
        fail: '/blog/posts'
      },
      component: lazyLoading('blog/Post', false)
    },
    {
      name: 'Photos',
      path: '/photos',
      meta: {
        label: 'Фотопоток',
        icon: 'fa-picture-o',
        inSideBar: true,
        can: 'show Photo',
        fail: '/'
      },
      component: lazyLoading('files/Photos', false)
    },
    {
      name: 'Photo',
      path: '/photos/:id',
      meta: {
        label: 'Изображение',
        inSideBar: false,
        can: 'show Photo',
        fail: '/photos'
      },
      component: lazyLoading('files/Photo', false)
    },
    {
      name: 'Doctor',
      path: '/doctors/:id',
      meta: {
        label: 'Доктор',
        inSideBar: false,
        can: 'show Doctor',
        fail: '/doctors'
      },
      component: lazyLoading('doctors/Doctor', false)
    },
    {
      name: 'ScheduleOfDoctor',
      path: '/schedule-of-doctors/:id',
      meta: {
        label: 'Расписание врача',
        inSideBar: false
      },
      component: lazyLoading('appointments/ScheduleOfDoctor', false)
    },
    // {
    //   name: 'Examination',
    //   path: '/schedule/examinations/:id/:subjId',
    //   meta: {
    //     label: 'Виды приемов',
    //     inSideBar: false,
    //     can: 'show Examination',
    //     fail: '/schedule/examinations'
    //   },
    //   component: lazyLoading('appointments/Examination', false)
    // },
    {
      name: 'HouseCallMap',
      path: '/house-call-maps/:id',
      meta: {
        label: 'Вызов на дом',
        inSideBar: false,
        can: 'update HouseCallMap',
        fail: '/house-call-maps'
      },
      component: lazyLoading('appointments/HouseCallMap', false)
    },
    {
      name: 'WhatDoWeTreat',
      meta: {
        label: 'Что мы лечим',
        icon: 'fa-heartbeat',
        expanded: false
      },
      children: [
        {
          name: 'Symptoms',
          path: '/symptoms',
          meta: {
            label: 'Симптомы',
            can: 'show Symptom',
            fail: '/symptoms'
          },
          component: lazyLoading('what-do-we-treat/Symptoms', false)
        },
        {
          name: 'Diseases',
          path: '/diseases',
          meta: {
            label: 'Болезни',
            can: 'show Disease',
            fail: '/diseases'
          },
          component: lazyLoading('what-do-we-treat/Diseases', false)
        },
        {
          name: 'Procedures',
          path: '/procedures',
          meta: {
            label: 'Процедуры',
            can: 'show Procedure',
            fail: '/procedures'
          },
          component: lazyLoading('what-do-we-treat/Procedures', false)
        }
      ]
    },
    {
      name: 'Collaborators',
      meta: {
        label: 'ЛК МедПрофи',
        icon: 'fa-heartbeat',
        expanded: false
      },
      children: [
        {
          name: 'CollabDoctors',
          path: '/collaborate/users',
          meta: {
            label: 'Врачи',
            can: 'show Collab',
            fail: '/collaborate'
          },
          component: lazyLoading('collaborate/Users', false)
        },
        {
          name: 'CollabOrganizations',
          path: '/collaborate/org',
          meta: {
            label: 'Организации',
            can: 'show Collab',
            fail: '/collaborate'
          },
          component: lazyLoading('collaborate/Org', false)
        },
        {
          name: 'CollabPayments',
          path: '/collaborate/payments',
          meta: {
            label: 'Выплаты',
            can: 'show Collab',
            fail: '/collaborate'
          },
          component: lazyLoading('collaborate/Payments', false)
        }
      ]
    },
    {
      name: 'CollabDoctor',
      path: '/collaborate/:id',
      meta: {
        label: 'Врач',
        inSideBar: false,
        can: 'show Collab',
        fail: '/collaborate'
      },
      component: lazyLoading('collaborate/User', false)
    },
    {
      name: 'Symptom',
      path: '/symptoms/:id',
      meta: {
        label: 'Симптом',
        inSideBar: false,
        can: 'show Symptom',
        fail: '/symptoms'
      },
      component: lazyLoading('what-do-we-treat/Symptom', false)
    },
    {
      name: 'Disease',
      path: '/diseases/:id',
      meta: {
        label: 'Болезнь',
        inSideBar: false,
        can: 'show Disease',
        fail: '/diseases'
      },
      component: lazyLoading('what-do-we-treat/Disease', false)
    },
    {
      name: 'Procedure',
      path: '/procedures/:id',
      meta: {
        label: 'Процедура',
        inSideBar: false,
        can: 'show Procedure',
        fail: '/procedures'
      },
      component: lazyLoading('what-do-we-treat/Procedure', false)
    },
    // {
    //   name: 'RefundRequest',
    //   path: '/refunds/request',
    //   meta: {
    //     label: 'Запрос на возврат',
    //     icon: 'fa-money',
    //     inSideBar: true
    //   },
    //   component: lazyLoading('payments/RefundRequest', false)
    // },
    {
      name: 'Cmes',
      path: '/cmes',
      meta: {
        label: 'CME',
        icon: 'fa-universal-access',
        inSideBar: true
      },
      component: lazyLoading('cme/Cme', false)
    },
    {
      name: 'Cme',
      path: '/cmes/:id',
      meta: {
        label: 'CME',
        icon: 'fa-universal-access',
        inSideBar: false
      },
      component: lazyLoading('cme/CmeItem', false)
    },
    {
      name: 'DoctorCalendar',
      path: '/doctor/calendar',
      meta: {
        label: 'Мое расписание',
        can: 'show_calendar Doctor',
        icon: 'fa-calendar',
        inSideBar: true
      },
      redirect: { name: 'EmployeeScheduleCurrentItems' },
      component: lazyLoading('employee-schedule/Base', false),
      children: [
        {
          name: 'EmployeeScheduleCurrentItems',
          path: 'current',
          meta: {
            label: 'Правила',
            can: 'show_calendar Doctor',
            inSideBar: false
          },
          props: { _type: 'active' },
          component: lazyLoading('employee-schedule/DoctorCalendarItemList', false)
        },
        {
          name: 'EmployeeScheduleArchivedItems',
          path: 'archived',
          meta: {
            label: 'Архив правил',
            can: 'show_calendar Doctor',
            inSideBar: false
          },
          props: { _type: 'archived' },
          component: lazyLoading('employee-schedule/DoctorCalendarItemList', false)
        },
        {
          name: 'EmployeeScheduleCalendarWidget',
          path: 'widget',
          meta: {
            label: 'Календарь',
            can: 'show_calendar Doctor',
            inSideBar: false
          },
          component: lazyLoading('employee-schedule/CalendarWidget', false)
        },
        {
          name: 'ChiefRequest',
          path: 'chief-request',
          meta: {
            label: 'Задание главврача',
            can: 'show_calendar Doctor',
            inSideBar: false
          },
          component: lazyLoading('employee-schedule/ChiefRequest', false)
        }
      ]
    },
    {
      name: 'DoctorCalendarItem',
      path: '/doctor/calendar/:id',
      meta: {
        label: 'Мое расписание',
        icon: 'fa-calendar',
        can: 'show_calendar Doctor',
        inSideBar: false
      },
      component: lazyLoading('employee-schedule/DoctorCalendarItem', false)
    },
    {
      name: 'Paysheets',
      path: '/paysheets',
      meta: {
        label: 'Расчетный лист',
        icon: 'fa-object-group'
      },
      component: lazyLoading('paysheet/Paysheet', false)
    },
    {
      name: 'FunctionalTestingReport',
      path: '/functional-testing/report',
      meta: {
        label: 'Функ. тестирование',
        icon: 'fa-bicycle',
        inSideBar: true,
        can: 'show FunctionalTestingReport'
      },
      component: lazyLoading('functional-testing/Report', false)
    },
    {
      name: 'Messengers',
      path: '/messengers',
      meta: {
        label: 'Сообщения',
        icon: 'fa-pencil-square-o',
        inSideBar: true,
        can: 'show Messengers',
        fail: '/'
      },
      component: lazyLoading('messengers/Messengers', false)
    },
    {
      name: 'Jobs',
      path: '/jobs',
      meta: {
        label: 'Вакансии',
        icon: 'fa-pencil-square-o',
        inSideBar: true,
        can: 'show Jobs',
        fail: '/'
      },
      component: lazyLoading('jobs/Jobs', false)
    },
    {
      name: 'Job',
      path: '/jobs/:id',
      meta: {
        label: 'Вакансия',
        inSideBar: false,
        fail: '/jobs'
      },
      component: lazyLoading('jobs/Job', false)
    },
    {
      name: 'Pages',
      path: '/pages',
      meta: {
        label: 'Страницы',
        icon: 'fa-file-powerpoint-o',
        inSideBar: true,
        can: 'show Pages',
        fail: '/'
      },
      component: lazyLoading('pages/Pages', false)
    },
    {
      name: 'Page',
      path: '/pages/:id',
      meta: {
        label: 'Страница',
        inSideBar: false,
        fail: '/pages'
      },
      component: lazyLoading('pages/Page', false)
    },
    {
      name: 'Lectures',
      path: '/lectures',
      meta: {
        label: 'Лекции',
        icon: 'fa-file-powerpoint-o',
        inSideBar: true,
        can: 'show Lecture',
        fail: '/'
      },
      component: lazyLoading('lectures/Lectures', false)
    },
    {
      name: 'Lecture',
      path: '/lectures/:id',
      meta: {
        label: 'Лекция',
        inSideBar: false,
        can: 'create Lecture',
        fail: '/lectures'
      },
      component: lazyLoading('lectures/Lecture', false)
    },
    {
      name: 'InformerNotificationsList',
      path: '/notifications',
      meta: {
        label: 'Перетяжки',
        icon: 'notification_important',
        can: 'show InformerNotifications',
        inSideBar: true
      },
      component: lazyLoading('informer/Notifications', false)
    },
    {
      name: 'InformerNotificationEdit',
      path: '/notifications/:id',
      meta: {
        label: 'Перетяжка',
        inSideBar: false,
        can: 'show InformerNotifications',
        fail: '/notifications'
      },
      component: lazyLoading('informer/Notification', false)
    },
    {
      name: 'BI',
      path: '/bi',
      meta: {
        icon: 'fa-calculator',
        label: 'Операционная прибыль'
      },
      component: lazyLoading('Bi', false)
    },
    {
      name: 'PaymentRequest',
      path: '/payment-request',
      meta: {
        icon: 'fa-hdd-o',
        label: 'Заявка на оплату'
      },
      component: lazyLoading('PaymentRequest', false)
    }
  ]
}

const mutations = {
  [types.EXPAND_MENU] (state, menuItem) {
    if (menuItem.index > -1) {
      if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
        state.items[menuItem.index].meta.expanded = menuItem.expanded
      }
    } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
      menuItem.item.meta.expanded = menuItem.expanded
    }
  }
}

export default {
  state,
  mutations
}
